import { inject, Injectable } from '@angular/core';
import { DEFAULT_CITY } from '@lentau/city/shared/constants';
import { Region } from 'angular-api-gateway/v1/model/region';
import { AppStateCacheService } from '@lentau/core/app-state-cache/shared/app-state-cache.service';
import { withCacheErrorHandling } from '@lentau/core/app-state-cache/shared/cache-error.decorator';
import { AppCacheKeys } from '@lentau/core/app-state-cache/shared/cache.constants';
import { isUtk } from '@lentau/ui-kit/core/helpers/isBrand.helper';
import { BrowserApiSupportService } from '@lentau/ui-kit/core/services/browser-api-support/browser-api-support.service';

@Injectable({
  providedIn: 'root',
})
export class CityCacheService {
  private appStateCacheService: AppStateCacheService = inject(AppStateCacheService);
  private browserApiSupportService: BrowserApiSupportService = inject(BrowserApiSupportService);

  // Для SSR и Утконоса берём дэфолтный город
  // Для клиента сперва проверяем кэш и если нет - берём с бэка
  @withCacheErrorHandling(AppCacheKeys.City)
  public getInitCity(): Region {
    if (this.browserApiSupportService.isSearchBot() || isUtk()) {
      return DEFAULT_CITY;
    }

    const city: string = this.appStateCacheService.get(AppCacheKeys.City);

    // Если кеш пустой
    if (!city) {
      return null;
    }

    return JSON.parse(city);
  }

  public updateCacheCity(city: Region): void {
    const currentCity: Region = this.appStateCacheService.get(AppCacheKeys.City);

    if (!currentCity || currentCity !== city) {
      this.appStateCacheService.set(AppCacheKeys.City, JSON.stringify(city));
    }
  }
}
